// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationV2UserUpdateAnyUserIdUpdateAnyUserResponse {
    static getAttributeTypeMap() {
        return AuthenticationV2UserUpdateAnyUserIdUpdateAnyUserResponse.attributeTypeMap;
    }
}
AuthenticationV2UserUpdateAnyUserIdUpdateAnyUserResponse.discriminator = undefined;
AuthenticationV2UserUpdateAnyUserIdUpdateAnyUserResponse.additionalProperties = false;
AuthenticationV2UserUpdateAnyUserIdUpdateAnyUserResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=authenticationV2UserUpdateAnyUserIdUpdateAnyUserResponse.js.map